import React from 'react';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';
import toShort from '../../../../../services/utils/dateParser'

import css from './DownloadAttList.module.css'

import attListTemplate from '../../../../../library/templates/attListTemplate.docx'

const DownloadAttList = ({ data }) => {
  data = data.sort((a,b) => a.studentName.localeCompare(b.studentName))
    const loadFile = (url, callback) => {
          fetch(url)
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              console.log(response);
              return response.arrayBuffer();
            })
            .then(data => callback(null, data))
            .catch(err => callback(err, null));
        };
      
        const generateDocument = () => {
          loadFile(attListTemplate, (err, content) => {
            // console.log(`${process.env.PUBLIC_URL}/template/attListTemplate.docx`);
            if (err) {
              console.error('Error loading the template:', err);
              return;
            }
      
            try {
              const zip = new PizZip(content);
              const doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true,
              });

              doc.setData({
                courseNo: data[0].courseNo || '',
                courseTitle: data[0].courseTitle || '',
                courseStart: toShort(data[0].courseStart) || '',
                courseEnd: toShort(data[0].courseEnd) || '',
                coursePlace: data[0].courseLocation || '',
                student1: data[0] ? `(${data[0].studentNo}) ${data[0].studentName} (${data[0].customerNameShort})\t${data[0].licenseCategoryTitle}` : '',
                student2: data[1] ? `(${data[1].studentNo}) ${data[1].studentName} (${data[1].customerNameShort})\t${data[1].licenseCategoryTitle}` : '',
                student3: data[2] ? `(${data[2].studentNo}) ${data[2].studentName} (${data[2].customerNameShort})\t${data[2].licenseCategoryTitle}` : '',
                student4: data[3] ? `(${data[3].studentNo}) ${data[3].studentName} (${data[3].customerNameShort})\t${data[3].licenseCategoryTitle}` : '',
                student5: data[4] ? `(${data[4].studentNo}) ${data[4].studentName} (${data[4].customerNameShort})\t${data[4].licenseCategoryTitle}` : '',
                student6: data[5] ? `(${data[5].studentNo}) ${data[5].studentName} (${data[5].customerNameShort})\t${data[5].licenseCategoryTitle}` : '',
                student7: data[6] ? `(${data[6].studentNo}) ${data[6].studentName} (${data[6].customerNameShort})\t${data[6].licenseCategoryTitle}` : '',
                student8: data[7] ? `(${data[7].studentNo}) ${data[7].studentName} (${data[7].customerNameShort})\t${data[7].licenseCategoryTitle}` : '',
                student9: data[8] ? `(${data[8].studentNo}) ${data[8].studentName} (${data[8].customerNameShort})\t${data[8].licenseCategoryTitle}` : '',
                student10: data[9] ? `(${data[9].studentNo}) ${data[9].studentName} (${data[9].customerNameShort})\t${data[9].licenseCategoryTitle}` : '',
                student11: data[10] ? `(${data[10].studentNo}) ${data[10].studentName} (${data[10].customerNameShort})\t${data[10].licenseCategoryTitle}` : '',
                student12: data[11] ? `(${data[11].studentNo}) ${data[11].studentName} (${data[11].customerNameShort})\t${data[11].licenseCategoryTitle}` : '',
                student13: data[12] ? `(${data[12].studentNo}) ${data[12].studentName} (${data[12].customerNameShort})\t${data[12].licenseCategoryTitle}` : '',
                student14: data[13] ? `(${data[13].studentNo}) ${data[13].studentName} (${data[13].customerNameShort})\t${data[13].licenseCategoryTitle}` : '',
                student15: data[14] ? `(${data[14].studentNo}) ${data[14].studentName} (${data[14].customerNameShort})\t${data[14].licenseCategoryTitle}` : '',
                student16: data[15] ? `(${data[15].studentNo}) ${data[15].studentName} (${data[15].customerNameShort})\t${data[15].licenseCategoryTitle}` : '',
                student17: data[16] ? `(${data[16].studentNo}) ${data[16].studentName} (${data[16].customerNameShort})\t${data[16].licenseCategoryTitle}` : '',
                student18: data[17] ? `(${data[17].studentNo}) ${data[17].studentName} (${data[17].customerNameShort})\t${data[17].licenseCategoryTitle}` : '',
                student19: data[18] ? `(${data[18].studentNo}) ${data[18].studentName} (${data[18].customerNameShort})\t${data[18].licenseCategoryTitle}` : '',
                student20: data[19] ? `(${data[19].studentNo}) ${data[19].studentName} (${data[19].customerNameShort})\t${data[19].licenseCategoryTitle}` : '',
                student21: data[20] ? `(${data[20].studentNo}) ${data[20].studentName} (${data[20].customerNameShort})\t${data[20].licenseCategoryTitle}` : '',
                student22: data[21] ? `(${data[21].studentNo}) ${data[21].studentName} (${data[21].customerNameShort})\t${data[21].licenseCategoryTitle}` : '',
                student23: data[22] ? `(${data[22].studentNo}) ${data[22].studentName} (${data[22].customerNameShort})\t${data[22].licenseCategoryTitle}` : '',
                student24: data[23] ? `(${data[23].studentNo}) ${data[23].studentName} (${data[23].customerNameShort})\t${data[23].licenseCategoryTitle}` : '',
                student25: data[24] ? `(${data[24].studentNo}) ${data[24].studentName} (${data[24].customerNameShort})\t${data[24].licenseCategoryTitle}` : '',
                student26: data[25] ? `(${data[25].studentNo}) ${data[25].studentName} (${data[25].customerNameShort})\t${data[25].licenseCategoryTitle}` : '',
                student27: data[26] ? `(${data[26].studentNo}) ${data[26].studentName} (${data[26].customerNameShort})\t${data[26].licenseCategoryTitle}` : '',
                student28: data[27] ? `(${data[27].studentNo}) ${data[27].studentName} (${data[27].customerNameShort})\t${data[27].licenseCategoryTitle}` : '',
              });
      
              doc.render();
      
              const blob = doc.getZip().generate({
                type: 'blob',
                mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              });
      
              saveAs(blob, `#${data[0].courseNo}_${data[0].courseTitle}_Weekly Attendance Sheet.docx`);
            } catch (error) {
              console.error('Error rendering the document:', error);
            }
          });
        };
      
        return (
          <div>
            <button className={css.button} onClick={generateDocument}>Download</button>
          </div>
        );
      };

export default DownloadAttList;
